export default __webpack_public_path__ + "37fe7e557db0bb12f6b08dd5c4105685.svg";